import { createFileRoute } from "@tanstack/react-router";
import { InsightsUsagePage } from "../../../components/system/InsightsUsagePage";
import { requireSuperAdmin } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/insights/")({
  beforeLoad: requireSuperAdmin(),
  component: SystemInsightsRoute,
});

function SystemInsightsRoute() {
  return <InsightsUsagePage />;
}
